(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["multiple-grid-item"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('multiple-grid-tabs')) {
    class MultipleGridTabs extends HTMLElement {
      constructor() {
        super();
        this.handleClick = this.handleClick.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
      }

      connectedCallback() {
        this.removeEventListener('click', this.handleClick);
        this.removeEventListener('keydown', this.handleKeydown);
        this.addEventListener('click', this.handleClick);
        this.addEventListener('keydown', this.handleKeydown);
        this.selectTab(this.dataset.selectedTabId || '1', false);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        this.removeEventListener('keydown', this.handleKeydown);
      }

      handleClick(event) {
        const target = event.target.closest('[data-multiple-grid-tab-name][data-id]');
        if (!target || !this.contains(target)) return;

        event.preventDefault();
        this.selectTab(target.dataset.id);
      }

      handleKeydown(event) {
        if (event.key !== 'Enter') return;

        const target = event.target.closest('[data-multiple-grid-tab-name][data-id]');
        if (!target || !this.contains(target)) return;

        event.preventDefault();
        this.selectTab(target.dataset.id);
      }

      selectTab(tabId, refreshCarousel = true) {
        const panels = [...this.querySelectorAll('[data-multiple-grid-tab]')];
        const activePanel = panels.find((panel) => panel.dataset.id === tabId);
        if (!activePanel) return;

        this.dataset.selectedTabId = tabId;
        this.querySelectorAll('[data-multiple-grid-tab-name]').forEach((name) => {
          name.classList.toggle('selected', name.dataset.id === tabId);
        });

        panels.forEach((panel) => {
          const isActive = panel === activePanel;
          panel.hidden = !isActive;
          panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });

        if (refreshCarousel) this.refreshPanel(activePanel);
      }

      refreshPanel(panel) {
        requestAnimationFrame(() => {
          panel.querySelectorAll('carousel-component').forEach((carousel) => {
            if (typeof carousel.reInit === 'function') carousel.reInit();
          });

          const video = panel.querySelector('video[autoplay]');
          if (video) video.play().catch(() => {});
        });
      }
    }

    customElements.define('multiple-grid-tabs', MultipleGridTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-custom-overview"] && !Shopify.designMode) return;
  try {
    
  const CONFIG = {
    ACTIVE_CLASS: 'active',
    TEXT_ICON_PREFIX: 'text-icon-',
    IMAGE_BOX_PREFIX: 'image-box-',
  };
  const toggleActive = (elems, targetElem) => {
    if (!elems || !targetElem || targetElem.classList.contains(CONFIG.ACTIVE_CLASS)) return;
    elems.forEach((item) => item.classList.remove(CONFIG.ACTIVE_CLASS));
    targetElem.classList.add(CONFIG.ACTIVE_CLASS);
  };
  const getElementIndex = (collection, element) => {
    if (!collection || !element) return -1;
    return Array.from(collection).indexOf(element);
  };
  const debounce = (fn, delay = 100) => {
    let timer = null;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        fn && fn(...args);
      }, delay);
    };
  };
  const initSection8 = () => {
    const section8 = document.querySelector('.section-secure');
    if (!section8) return;
    const imageBoxItems = section8.querySelectorAll('.image-box-item');
    const textIconHeads = section8.querySelectorAll('.text-icon-head');
    const productTexts = section8.querySelectorAll('.product-text');
    const handleSection8Click = (e) => {
      const textHeadElem = e.target.closest('.text-icon-head');
      const index = getElementIndex(textIconHeads, textHeadElem);
      if (index === -1) return;
      const currentIndex = index + 1;
      const targetText = section8.querySelector(`.${CONFIG.TEXT_ICON_PREFIX}${currentIndex}`);
      const targetImage = section8.querySelector(`.${CONFIG.IMAGE_BOX_PREFIX}${currentIndex}`);
      toggleActive(productTexts, targetText);
      toggleActive(imageBoxItems, targetImage);
    };
    const handleSection8Resize = () => {
      const activeTexts = section8.querySelectorAll(`.product-text.${CONFIG.ACTIVE_CLASS}`);
      if (!activeTexts.length) return;
      activeTexts.forEach((item, i) => i > 0 && item.classList.remove(CONFIG.ACTIVE_CLASS));
      const firstActiveText = activeTexts[0];
      const activeIndexClass = [...firstActiveText.classList].find((cls) => cls.startsWith(CONFIG.TEXT_ICON_PREFIX));
      if (!activeIndexClass) return;
      const activeIndex = parseInt(activeIndexClass.split('-')[2], 10);
      if (isNaN(activeIndex)) return;
      const targetImage = section8.querySelector(`.${CONFIG.IMAGE_BOX_PREFIX}${activeIndex}`);
      toggleActive(imageBoxItems, targetImage);
    };
    section8.addEventListener('click', handleSection8Click);
    const debouncedResize = debounce(handleSection8Resize);
    window.addEventListener('resize', debouncedResize);
    return () => {
      section8.removeEventListener('click', handleSection8Click);
      window.removeEventListener('resize', debouncedResize);
    };
  };
  if (!customElements.get('vl-overview-mode-controller')) {
    class VLOverviewModeController extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;
        this.textCarousel = this.querySelector('[data-overview-mode-text]');
        this.mediaCarousel = this.querySelector('[data-overview-mode-media]');
        this.mediaSlides = Array.from(this.querySelectorAll('[data-overview-mode-media] [data-vl-carousel-slide]'));
        if (!this.textCarousel || !this.mediaCarousel || !this.mediaSlides.length) return;

        this.abortController = new AbortController();
        const { signal } = this.abortController;
        this.addEventListener('vl:carousel:change', (event) => this.handleCarouselChange(event), { signal });
        this.addEventListener('vl:carousel:ready', (event) => this.handleCarouselReady(event), { signal });
        this.select(0, null, 'initial');
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.abortController = null;
      }

      handleCarouselReady(event) {
        if (event.target !== this.textCarousel && event.target !== this.mediaCarousel) return;
        const index = Number(event.detail?.index) || 0;
        this.select(index, event.target, 'ready');
      }

      handleCarouselChange(event) {
        if (event.target !== this.textCarousel && event.target !== this.mediaCarousel) return;
        const index = Number(event.detail?.index) || 0;
        this.select(index, event.target, 'mode-sync');
      }

      select(index, source, reason) {
        const nextIndex = Math.max(0, Math.min(Number(index) || 0, this.mediaSlides.length - 1));
        if (source !== this.textCarousel && this.textCarousel.selectedIndex !== nextIndex) {
          this.textCarousel.goTo?.(nextIndex, { reason, userInitiated: false });
        }
        if (source !== this.mediaCarousel && this.mediaCarousel.selectedIndex !== nextIndex) {
          this.mediaCarousel.goTo?.(nextIndex, { reason, userInitiated: false });
        }
        this.controlMedia(nextIndex);
        this.dataset.selectedIndex = String(nextIndex);
      }

      controlMedia(activeIndex) {
        this.mediaSlides.forEach((slide, index) => {
          const video = slide.querySelector('video');
          if (!video) return;
          if (index === activeIndex) video.play().catch((error) => console.log('视频播放失败:', error));
          else video.pause();
        });
      }
    }

    customElements.define('vl-overview-mode-controller', VLOverviewModeController);
  }
  if (!customElements.get('vl-overview-smart-controller')) {
    class VLOverviewSmartController extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;
        this.carousel = this.querySelector('[data-overview-smart-carousel]');
        this.tabs = Array.from(this.querySelectorAll('[data-overview-smart-tab]'));
        this.tabList = this.querySelector('.overview-smart-tabs');
        if (!this.carousel || !this.tabs.length || !this.tabList) return;

        this.abortController = new AbortController();
        const { signal } = this.abortController;
        this.lastActiveIndex = 0;
        this.addEventListener('click', (event) => this.handleClick(event), { signal });
        this.addEventListener('keydown', (event) => this.handleKeydown(event), { signal });
        this.carousel.addEventListener('vl:carousel:change', (event) => this.select(event.detail?.index), { signal });
        this.select(0, { scroll: false });
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.abortController = null;
      }

      handleClick(event) {
        const tab = event.target.closest('[data-overview-smart-tab]');
        if (!tab || !this.contains(tab)) return;
        this.goTo(Number(tab.dataset.index));
      }

      handleKeydown(event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        const tab = event.target.closest('[data-overview-smart-tab]');
        if (!tab || !this.contains(tab)) return;
        event.preventDefault();
        this.goTo(Number(tab.dataset.index));
      }

      goTo(index) {
        this.carousel.goTo?.(index, { reason: 'smart-tab', userInitiated: true });
      }

      select(index, options = {}) {
        const nextIndex = Math.max(0, Math.min(Number(index) || 0, this.tabs.length - 1));
        this.tabs.forEach((tab, tabIndex) => {
          const isActive = tabIndex === nextIndex;
          tab.classList.toggle(CONFIG.ACTIVE_CLASS, isActive);
          tab.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
        if (options.scroll !== false) this.scrollToActiveTab(nextIndex);
        this.dataset.selectedIndex = String(nextIndex);
      }

      scrollToActiveTab(activeIndex) {
        const activeTab = this.tabs[activeIndex];
        if (!activeTab) return;
        let scrollLeft = activeTab.offsetLeft - this.tabList.clientWidth / 6;
        if (activeIndex < this.lastActiveIndex) scrollLeft += this.tabList.clientWidth / 6;
        else if (activeIndex > this.lastActiveIndex) scrollLeft -= this.tabList.clientWidth / 4;
        const maxScrollLeft = this.tabList.scrollWidth - this.tabList.clientWidth;
        scrollLeft = Math.max(0, Math.min(scrollLeft, maxScrollLeft));
        this.tabList.scrollTo({ left: scrollLeft, behavior: 'smooth' });
        this.lastActiveIndex = activeIndex;
      }
    }

    customElements.define('vl-overview-smart-controller', VLOverviewSmartController);
  }
  document.addEventListener('DOMContentLoaded', () => {
    initSection8();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["specifications"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.specs-section').forEach((section) => {
      const toggleBtns = section.querySelectorAll('.specs-toggle-btn');
      const content = section.querySelector('.specs-content');
      const imgContainer = section.querySelector('.specs-img-container');
      const btnLayout = section.dataset.btnLayout || 'two';
      const buttonWrap = section.querySelector('.specs-btn');
      const variantEls = section.querySelectorAll('[data-specs-variant]');
      const variantButtons = section.querySelectorAll('[data-specs-variant-btn]');
      const axisButtons = section.querySelectorAll('[data-specs-axis][data-specs-value]');
      const itemRows = section.querySelectorAll('.flex-row-item, .grid-3-item');

      let activeRow1 = Number(section.dataset.defaultRow1 || 0);
      let activeRow2 = Number(section.dataset.defaultRow2 || 0);
      let activeVariant = Number(section.dataset.defaultVariant || 0);

      const isMeaningfulContent = (el) => {
        if (!el) return false;
        if (el.matches('picture')) return true;
        if (el.querySelector && el.querySelector('img, svg, video')) return true;
        const text = (el.textContent || '').replace(/\u00a0/g, ' ').trim();
        return text.length > 0;
      };

      const computeAvailableVariants = () => {
        const available = new Set();
        const pictures = imgContainer ? imgContainer.querySelectorAll('picture[data-specs-variant]') : [];
        const anyPictures = pictures.length > 0;
        const pictureByVariant = new Map();
        pictures.forEach((pic) => {
          const idx = Number(pic.dataset.specsVariant);
          if (!Number.isNaN(idx)) pictureByVariant.set(idx, true);
        });

        const countsByVariant = new Map();
        for (let i = 0; i < 4; i++) countsByVariant.set(i, 0);
        itemRows.forEach((row) => {
          for (let i = 0; i < 4; i++) {
            const cell = row.querySelector('[data-specs-variant="' + i + '"]');
            if (isMeaningfulContent(cell)) countsByVariant.set(i, (countsByVariant.get(i) || 0) + 1);
          }
        });

        const requiresInfo = itemRows.length > 0;
        for (let i = 0; i < 4; i++) {
          const hasInfo = !requiresInfo || (countsByVariant.get(i) || 0) > 0;
          const hasPicOk = !anyPictures || pictureByVariant.has(i);
          if (hasInfo && hasPicOk) available.add(i);
        }
        return available;
      };

      const availableVariants = computeAvailableVariants();
      const firstAvailable = () => {
        for (let i = 0; i < 4; i++) if (availableVariants.has(i)) return i;
        return null;
      };
      const normalizeVariant = (requested) => {
        const req = Number(requested);
        if (!Number.isNaN(req) && availableVariants.has(req)) return req;
        return firstAvailable();
      };

      const updateRowVisibility = () => {
        itemRows.forEach((row) => {
          const cell = row.querySelector('[data-specs-variant="' + activeVariant + '"]');
          row.hidden = !isMeaningfulContent(cell);
        });
      };

      const updateButtonVisibility = () => {
        if (!buttonWrap) return;
        const visibleVariants = Array.from(availableVariants.values());
        if (visibleVariants.length < 2) {
          buttonWrap.hidden = true;
          return;
        }
        buttonWrap.hidden = false;

        if (btnLayout === 'matrix') {
          const has00or01 = availableVariants.has(0) || availableVariants.has(1);
          const has10or11 = availableVariants.has(2) || availableVariants.has(3);
          const has00or10 = availableVariants.has(0) || availableVariants.has(2);
          const has01or11 = availableVariants.has(1) || availableVariants.has(3);

          axisButtons.forEach((btn) => {
            const axis = btn.dataset.specsAxis;
            const value = Number(btn.dataset.specsValue);
            let show = true;
            if (axis === 'row1') show = value === 0 ? has00or01 : has10or11;
            if (axis === 'row2') show = value === 0 ? has00or10 : has01or11;
            btn.hidden = !show;
          });
          const axisRows = buttonWrap.querySelectorAll('.specs-btn-row');
          axisRows.forEach((row) => {
            const buttons = row.querySelectorAll('button');
            row.hidden =
              buttons.length > 0 && Array.from(buttons).every((b) => b.hidden);
          });
        } else {
          variantButtons.forEach((btn) => {
            const v = Number(btn.dataset.specsVariantBtn);
            btn.hidden = !availableVariants.has(v);
          });
        }
      };

      const setVariant = (variantIndex) => {
        const normalized = normalizeVariant(variantIndex);
        if (normalized === null) {
          if (buttonWrap) buttonWrap.hidden = true;
          return;
        }
        activeVariant = normalized;
        if (btnLayout === 'matrix') {
          activeRow1 = Math.floor(activeVariant / 2);
          activeRow2 = activeVariant % 2;
        }

        variantEls.forEach((el) => {
          const isActive = Number(el.dataset.specsVariant) === activeVariant;
          el.classList.toggle('specs-show', isActive);
          el.classList.toggle('specs-hide', !isActive);
        });

        variantButtons.forEach((btn) => {
          const isActive = Number(btn.dataset.specsVariantBtn) === activeVariant;
          btn.classList.toggle('active', isActive);
          btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        axisButtons.forEach((btn) => {
          const axis = btn.dataset.specsAxis;
          const value = Number(btn.dataset.specsValue);
          const isActive =
            (axis === 'row1' && value === activeRow1) ||
            (axis === 'row2' && value === activeRow2);
          btn.classList.toggle('active', isActive);
          btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        updateRowVisibility();
        updateButtonVisibility();
      };

      const toggleSection = () => {
        content.classList.toggle('specs-content--expanded');
        content.classList.toggle('specs-content--collapsed');
        toggleBtns.forEach(btn => {
          btn.classList.toggle('specs-toggle-btn--expanded');
          btn.classList.toggle('specs-toggle-btn--collapsed');
        });
        if (imgContainer) imgContainer.classList.toggle('expanded');
      };

      const header = section.querySelector('.specs-header');
      if (header) header.addEventListener('click', toggleSection);
      toggleBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          toggleSection();
        });
      });
      if (content.classList.contains('specs-content--expanded') && imgContainer) {
        imgContainer.classList.add('expanded');
      }

      variantButtons.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          setVariant(Number(btn.dataset.specsVariantBtn));
        });
      });

      axisButtons.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          const axis = btn.dataset.specsAxis;
          const value = Number(btn.dataset.specsValue);
          if (axis === 'row1') activeRow1 = value;
          if (axis === 'row2') activeRow2 = value;
          let desired = activeRow1 * 2 + activeRow2;
          if (!availableVariants.has(desired)) {
            if (axis === 'row1') {
              const alt = activeRow1 * 2 + (activeRow2 === 0 ? 1 : 0);
              if (availableVariants.has(alt)) desired = alt;
            }
            if (axis === 'row2') {
              const alt = (activeRow1 === 0 ? 1 : 0) * 2 + activeRow2;
              if (availableVariants.has(alt)) desired = alt;
            }
          }
          setVariant(desired);
        });
      });

      setVariant(activeVariant);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
